import { Container } from "react-bootstrap";

export const Impressum = () => (
  <section className="impressum">
    <Container>
      <h2>Impressum</h2>
      <p>
        {/* Hier dein Impressum-Text */}
        Tobias Bollinger<br />
        Holsteinerweg 20<br />
        89191 Nellingen<br />
        E-Mail: info@bollinger-energieberatung.de<br />
        Telefon: 015782960601
      </p>
    </Container>
  </section>
);

export default Impressum;